module.exports = __webpack_public_path__ + "img/card2.a9c20979.jpg";